export enum PermissionName {
    Graduated = 'Pages.Graduated',
    Address = 'Pages.Address',
    SubDepartment = 'Pages.SubDepartment',
    Department = 'Pages.Department',
    Faculty = 'Pages.Faculty',
    Province = 'Pages.Province',
    District = 'Pages.District',
    Card = 'Pages.Card',
    Users = 'Pages.Users',
    UsersActivation = 'Pages.Users.Activation',
    Tenants = 'Pages.Tenants',
    Program = 'Pages.Program',
    Roles = 'Pages.Roles',
    Country = 'Pages.Country',
    University = 'Pages.University',
    PDPL = 'Pages.PDPL',
    GraduatedPanel = "Pages.GraduatedPanel",
    MyCompanyManage = "Pages.MyCompanyManage",
    JobAdvert = 'Pages.JobAdvert',
    ApplicationReview = "Pages.ApplicationReview",
    CompanyMonitoring = "Pages.CompanyMonitoring",
    JobMonitoring = "Pages.JobMonitoring",
    ApplicationMonitoring = "Pages.ApplicationMonitoring",
    EmailSend = "Pages.EmailSend",
    EmailTemplate = "Pages.EmailTemplate",
    EmailHistory = "Pages.EmailHistory",
    NewsCreate = "Pages.NewsCreate",
    Code = "Pages.Code",
    Location = "Pages.Location"
}
